<template>
  <div class="header-index">
    <div class="header-index-content">
      <div class="logo">
        <img src="../../assets/image/home_logo.png" alt="">
      </div>
      <div v-show="this.$store.state.isMobile" class="menu-icon-box" id="menu-icon-box" @click="changeMenu">
        <i class="iconfont">&#xe605;</i>
      </div>
      <div class="goENG" @click.stop="goENG" v-show="!this.$store.state.isMobile">ENG</div>
      <!-- pc端下拉菜单 -->
      <div class="menu-wrapper" v-show="!this.$store.state.isMobile">
        <ul class="nav-menu">
          <li
            class="menu-item"
            :class="{'active':isActive(item.path)}"
            v-for="(item,index) in navMenu"
            :key="index"
            @click="click(item.name)"
          >
            <router-link v-if="item.path" :to="item.path">
              <span :class="index == 5?'title_light':'title'">{{item.name}}</span>
            </router-link>
            <a v-if="item.path == ''" href="javascript:void(0)" @click="goAnchor('#contactUs')">
              <span class="title">{{item.name}}</span>
            </a>
            <div class="sublevel-box">
              <ul class="sublevel-ul">
                <li
                  class="sublevel_li"
                  v-for="(son,i) in item.sublevel"
                  :key="i"
                  @click="clickli(son.name)"
                >
                  <router-link :to="son.path">
                    <span class="name">{{son.name}}</span>
                  </router-link>
                </li>
              </ul>
            </div>
          </li>
          <li class="menu-item" :class="{'active':isActive()}">
            <a href="http://franchise.kidsrkidschina.com/index.php" target="_Blank">
              <span class="title_light">加盟合作</span>
            </a>
          </li>
        </ul>
      </div>
      <!-- 移动端下拉菜单 -->
      <div class="menu-wrapper" id="menu-wrapper-mobile"  v-show="this.$store.state.isMobile && mobileMenuVisible">
        <ul class="nav-menu">
          <li
            class="menu-item"
            :class="{'active':isActive(item.path)}"
            v-for="(item,index) in navMenu"
            :key="index"
            @click="click(item.name)"
          >
            <router-link v-if="item.path" :to="item.path">
              <span class="title">{{item.name}}</span>
            </router-link>
            <a v-if="item.path == ''" href="javascript:void(0)" @click="goAnchor('#contactUs')">
              <span class="title">{{item.name}}</span>
            </a>
          </li>
          <li class="menu-item" :class="{'active':isActive()}">
            <a href="http://franchise.kidsrkidschina.com/index.php" target="_Blank">
              <span class="title">加盟合作</span>
            </a>
          </li>
          <li class="menu-item" :class="{'active':isActive()}">
						<div @click.stop="goENG"><span class="title">ENG</span></div>
					</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mobileMenuVisible: false,
      navMenu: [
        { name: "首页", path: "/" },
        {
          name: "园所分布",
          path: "/kindergarten/index"
        },
        {
          name: "关于KRK",
          path: "/about",
          sublevel: [
            { name: "半个世纪的故事", path: "/about/story" },
            { name: "爱在中国", path: "/about/china" },
            { name: "KRK信念", path: "/about/belief" }
          ]
        },
        {
          name: "选择KRK",
          path: "/choose",
          sublevel: [
            { name: "核心优势", path: "/choose/advantage" },
            { name: "专业课程", path: "/choose/course" },
            { name: "QA体系", path: "/choose/qa" },
            { name: "透明管理", path: "/choose/manage" },
            { name: "食品健康", path: "/choose/foodhealth" },
            { name: "家长说", path: "/choose/parents" }
          ]
        },
        {
          name: "工作机会",
          path: "/join",
          sublevel: [
            { name: "KRK工作和生活", path: "/join/work" },
            { name: "立刻申请 Careers", path: "/careers" }
            //  {name:'给家长的一封信',path:'/join/letter'}
          ]
        },
        //  {name:"联系我们",path:''},
        { name: "家长预约", path: "/appointment?id=0" }
      ]
    };
  },
  created() {
    document.addEventListener("click", e => {
      var box = document.getElementById("menu-wrapper-mobile");
      var box2 = document.getElementById("menu-icon-box");
      if ((box2 && box2.contains(e.target)) || (box && box.contains(e.target))) {
        console.log('在内')
      } else {
        this.mobileMenuVisible = false;
      }
    });
  },
  methods: {
    isActive(path) {
      if (this.$route.path == "/" || path == "/") return;
      //              this.$route.path == path;
      else return path && this.$route.path.indexOf(path) > -1;
    },
    goENG() {
      this.$uweb.trackEvent("英文网站", "点击悬浮导航");
      window.open("https://kidsrkids.com/the-kids-r-kids-story");
    },
    goAnchor(selector) {
      var anchor = document.body.querySelector(selector);
      document.body.scrollTop = anchor.offsetTop; // chrome
      document.documentElement.scrollTop = anchor.offsetTop; // firefox
    },
    click(src) {
      this.mobileMenuVisible = !this.mobileMenuVisible;
      this.$uweb.trackEvent(src, "点击悬浮导航");
    },
    clickli(src) {
      this.$uweb.trackEvent(src, "点击悬浮导航");
    },
    changeMenu() {
      this.mobileMenuVisible = !this.mobileMenuVisible;
      console.log(this.mobileMenuVisible)
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss">
@import "@/assets/css/variables.scss";
.header-index {
  position: fixed;
  top: 30px;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 999;
  .header-index-content {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    position: relative;
  }
  .logo {
    width: 23%;
    height: auto;
    float: left;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  .goENG {
    position: absolute;
    top: 0px;
    right: 20px;
    color: #ffffff;
    font-size: 12px;
    cursor: pointer;
    font-family: ArialMT;
  }
  .menu-wrapper {
    float: right;
    margin-top: 30px;
    ul.nav-menu {
      z-index: 200;
      display: inline-block;
      vertical-align: top;
      height: 40px;
      li.menu-item {
        float: left;
        display: block;
        position: relative;
        .title {
          display: block;
          height: 40px;
          line-height: 40px;
          padding: 0 20px;
          background-color: $color-primary;
          color: #ffffff;
          font-size: 16px;
          cursor: pointer;
        }
        .title_light {
          display: block;
          height: 40px;
          line-height: 40px;
          padding: 0 20px;
          background-color: #ba9a40;
          color: #ffffff;
          font-size: 16px;
          cursor: pointer;
        }
        .sublevel-box {
          display: none;
          position: absolute;
          top: 35px;
          left: 0;
          padding-top: 5px;
          .sublevel-ul {
            margin-top: 4px;
            li.sublevel_li {
              width: 180px;
              height: 30px;
              line-height: 30px;
              text-align: center;
              font-size: 14px;
              color: #ffffff;
              background-color: rgba(0, 0, 0, 0.75);
              cursor: pointer;
              .name {
                color: #fff;
                display: block;
                width: 180px;
                height: 30px;
                line-height: 30px;
                text-align: center;
              }
            }
          }
          .sublevel-ul li.sublevel_li:hover {
            width: 180px;
            height: 30px;
            color: #fff;
            font-size: 14px;
            opacity: 1;
            cursor: pointer;
            background: rgba(0, 52, 120, 1);
          }
        }
      }
      li.menu-item:hover .sublevel-box {
        display: block;
      }
      li.menu-item:hover .sublevel-box .sublevel-ul .sublevel_li:hover {
        display: block;
      }
      li.menu-item:hover .title,
      li.menu-item.active .title {
        background: #094ca4;
      }
    }
  }
}
@media (max-width: 768px) {
  .header-index {
    top: 15px;
    .logo {
      width: 33%;
    }
    .header-index-content {
      width: 100%;
      padding: 0 22px 0 32px;
      box-sizing: border-box;
    }
    .menu-icon-box {
      float: right;
      width: 28px;
      height: 24px;
      background: rgba(0, 52, 120, 1);
      box-shadow: 3px 5px 6px 0px rgba(6, 1, 2, 0.09);
      opacity: 0.85;
      display: flex;
      align-items: center;
      justify-content: center;
      i {
        float: left;
        font-family: "iconfont" !important;
        font-size: 18px;
        font-style: normal;
        color: #fff;
      }
    }
    .menu-wrapper {
      position: absolute;
      right: 38px;
      top: 19px;
      margin: 0;
      clear: both;
      ul.nav-menu {
        z-index: 200;
        display: inline-block;
        vertical-align: top;
        height: 30px;
        width: 76px;
        li.menu-item {
          clear: both;
          display: block;
          position: relative;
          .title {
            display: block;
            width: 76px;
            text-align: center;
            height: 30px;
            line-height: 30px;
            padding: 0 8px;
            background-color: $color-primary;
            color: #ffffff;
            font-size: 12px;
            cursor: pointer;
          }
        }
        li.menu-item:hover .title,
        li.menu-item.active .title {
          background: #094ca4;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/header/HeaderIndex.vue